import Producto from './Producto'
export default Producto
